import { Link } from '@inertiajs/react'
import { ChevronRight } from 'lucide-react'

// Item de desfecho derivado pelo DigitalWorkers::AuditOutcomes (SZ-1600 C.5).
export interface AuditOutcomeItem {
  id: string
  source: 'fleet_session' | 'agent_chat' | 'eval_alert' | 'eval_verdict'
  title: string
  channel: string | null
  occurred_at: string | null
  reason: string
  href: string | null
}

const CHANNEL_LABELS: Record<string, string> = {
  chat: 'Chat',
  whatsapp: 'WhatsApp',
  'whatsapp-cloud': 'WhatsApp',
  telegram: 'Telegram',
  discord: 'Discord',
  msteams: 'Teams',
}

function formatDateTime(iso: string | null): string | null {
  if (!iso) return null
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

function RowContent({ item }: { item: AuditOutcomeItem }) {
  const timestamp = formatDateTime(item.occurred_at)
  return (
    <div className="flex items-start gap-3">
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-[13px] font-medium text-foreground truncate">{item.title}</span>
          {item.channel && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10.5px] font-medium bg-secondary text-muted-foreground shrink-0">
              {CHANNEL_LABELS[item.channel] ?? item.channel}
            </span>
          )}
        </div>
        <p className="mt-1 text-[13px] text-muted-foreground">{item.reason}</p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {timestamp && <span className="font-mono text-[11px] text-faint-foreground">{timestamp}</span>}
        {item.href && <ChevronRight className="size-4 text-muted-foreground" />}
      </div>
    </div>
  )
}

interface Props {
  items: AuditOutcomeItem[]
  count: number
  emptyMessage: string
}

export default function AuditOutcomeList({ items, count, emptyMessage }: Props) {
  // Estado vazio do DS: uma frase só, média.
  if (items.length === 0) {
    return <p className="px-4 py-6 text-[13px] text-muted-foreground">{emptyMessage}</p>
  }

  return (
    <div className="divide-y divide-border">
      {items.map((item) =>
        item.href ? (
          <Link key={item.id} href={item.href} className="block px-4 py-3 hover:bg-accent/50 transition-colors">
            <RowContent item={item} />
          </Link>
        ) : (
          <div key={item.id} className="px-4 py-3">
            <RowContent item={item} />
          </div>
        )
      )}
      {count > items.length && (
        <p className="px-4 py-2 text-xs text-muted-foreground">
          Mostrando {items.length} de {count} itens do período.
        </p>
      )}
    </div>
  )
}
